/**
 * 
 */
const PAYMENT_STATUS_PROCEEDING = 0;
const PAYMENT_STATUS_SUCCESS = 1;
const PAYMENT_STATUS_CANCEL = 2;
const PAYMENT_STATUS_INVALID_FOR_TIMEOUT = 3;
const PAYMENT_STATUS_INVALID_FOR_CANCEL = 4;

const PAYMENT_TIMEOUT_SECOND_PERIOD = 15 * 60;

/**
 * 
 */
const DELIVERY_TYPE_2_HOURS_ARRIVE = 1;
const DELIVERY_TYPE_NEXT_DAY_ARRIVE = 2;
const DELIVERY_TYPE_SELF_PICK = 3;
const DELIVERY_TYPE_TAKEOUT = 4;

/**
 * 
 */
const TRANSPORTATION_MODE_SUSPEND = 0;
const TRANSPORTATION_MODE_2_HOURS_ARRIVE = 1;
const TRANSPORTATION_MODE_INSIDE_FENCING = 2;
const TRANSPORTATION_MODE_OUTSIDE_FENCING = 3;
const TRANSPORTATION_MODE_TAKEOUT = 4;

const SHOP_TYPE_NORMAL = 0;
const SHOP_TYPE_TAKEOUT = 1; 

/**
 * 
 */
const AURORA_MSG_TYPE_SINGLE = 3;
const AURORA_MSG_TYPE_GROUP = 4;

/**
 * 
 */
const MSG_STATE_SEND_PROCEEDING = 0;
const MSG_STATE_SEND_SUCCESS_NOT_READ = 1;
const MSG_STATE_SEND_FAILED = 2;
const MSG_STATE_SEND_SUCCESS_HAS_READ = 3;
const MSG_STATE_SEND_SUCCESS = 4;

//
const MSG_CONTENT_TYPE_TEXT = 'text';
const MSG_CONTENT_TYPE_IMG = 'image';
const MSG_CONTENT_TYPE_FILE = 'file';

//
const AURORA_INIT_MAX_TIMES = 20;
const AURORA_INIT_WAIT_DURATION_EACH_TRY = 500;

//
const CONTENT_STATE_LOADING = 1;
const CONTENT_STATE_LOAD_FAIL = 2;
const CONTENT_STATE_LOAD_SUCCESS = 3;

/**
 * 
 */
const DIGIT_CARD_VERIFY_CODE_CAN_GET_TIMESTAMP = "yqy_shop_digitCartVerifyCodeCanGetTimestamp";
const DIGITAL_CARD_VERIFY_CODE_USEFUL_TIME = 60 * 3;

/**
 * 
 */
export {
    /**
     * 
     */
    PAYMENT_STATUS_PROCEEDING,
    PAYMENT_STATUS_SUCCESS,
    PAYMENT_STATUS_CANCEL,
    PAYMENT_STATUS_INVALID_FOR_TIMEOUT,
    PAYMENT_STATUS_INVALID_FOR_CANCEL,
    PAYMENT_TIMEOUT_SECOND_PERIOD,
    
    /**
     * 
     */
    DELIVERY_TYPE_2_HOURS_ARRIVE,
    DELIVERY_TYPE_NEXT_DAY_ARRIVE,
    DELIVERY_TYPE_SELF_PICK,
    DELIVERY_TYPE_TAKEOUT,

    /**
     * 
     */
    TRANSPORTATION_MODE_SUSPEND,
    TRANSPORTATION_MODE_2_HOURS_ARRIVE,
    TRANSPORTATION_MODE_INSIDE_FENCING,
    TRANSPORTATION_MODE_OUTSIDE_FENCING,
    TRANSPORTATION_MODE_TAKEOUT,

    /**
     * 
     */
    SHOP_TYPE_NORMAL,
    SHOP_TYPE_TAKEOUT,

    /**
     * 
     */
    AURORA_MSG_TYPE_SINGLE,
    AURORA_MSG_TYPE_GROUP,

    /**
     * 
     */
    MSG_STATE_SEND_PROCEEDING,
    MSG_STATE_SEND_SUCCESS_NOT_READ,
    MSG_STATE_SEND_FAILED,
    MSG_STATE_SEND_SUCCESS_HAS_READ,
    MSG_STATE_SEND_SUCCESS,

    /**
     * 
     */
    MSG_CONTENT_TYPE_TEXT,
    MSG_CONTENT_TYPE_IMG,
    MSG_CONTENT_TYPE_FILE,

    /**
     * 
     */
    AURORA_INIT_MAX_TIMES,
    AURORA_INIT_WAIT_DURATION_EACH_TRY,

    /**
     * 
     */
    CONTENT_STATE_LOADING,
    CONTENT_STATE_LOAD_FAIL,
    CONTENT_STATE_LOAD_SUCCESS,

    /**
     * 
     */
    DIGIT_CARD_VERIFY_CODE_CAN_GET_TIMESTAMP,
    DIGITAL_CARD_VERIFY_CODE_USEFUL_TIME,
}

export default {
    /**
     * 
     */
    PAYMENT_STATUS_PROCEEDING,
    PAYMENT_STATUS_SUCCESS,
    PAYMENT_STATUS_CANCEL,
    PAYMENT_STATUS_INVALID_FOR_TIMEOUT,
    PAYMENT_STATUS_INVALID_FOR_CANCEL,
    PAYMENT_TIMEOUT_SECOND_PERIOD,

    /**
     * 
     */
    DELIVERY_TYPE_2_HOURS_ARRIVE,
    DELIVERY_TYPE_NEXT_DAY_ARRIVE,
    DELIVERY_TYPE_SELF_PICK,
    DELIVERY_TYPE_TAKEOUT,

    /**
     * 
     */
    TRANSPORTATION_MODE_SUSPEND,
    TRANSPORTATION_MODE_2_HOURS_ARRIVE,
    TRANSPORTATION_MODE_INSIDE_FENCING,
    TRANSPORTATION_MODE_OUTSIDE_FENCING,
    TRANSPORTATION_MODE_TAKEOUT,

    /**
     * 
     */
    SHOP_TYPE_NORMAL,
    SHOP_TYPE_TAKEOUT,

    /**
     * 
     */
    AURORA_MSG_TYPE_SINGLE,
    AURORA_MSG_TYPE_GROUP,

    /**
     * 
     */
    MSG_STATE_SEND_PROCEEDING,
    MSG_STATE_SEND_SUCCESS_NOT_READ,
    MSG_STATE_SEND_FAILED,
    MSG_STATE_SEND_SUCCESS_HAS_READ,
    MSG_STATE_SEND_SUCCESS,

    /**
     * 
     */
    MSG_CONTENT_TYPE_TEXT,
    MSG_CONTENT_TYPE_IMG,
    MSG_CONTENT_TYPE_FILE,

    /**
     * 
     */
    AURORA_INIT_MAX_TIMES,
    AURORA_INIT_WAIT_DURATION_EACH_TRY,

    /**
     * 
     */
    CONTENT_STATE_LOADING,
    CONTENT_STATE_LOAD_FAIL,
    CONTENT_STATE_LOAD_SUCCESS,

    /**
     * 
     */
    DIGIT_CARD_VERIFY_CODE_CAN_GET_TIMESTAMP,
    DIGITAL_CARD_VERIFY_CODE_USEFUL_TIME,
}